module.exports = __webpack_public_path__ + "img/reject_message_example_2.8ba36299.png";